import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading, token } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-sand flex items-center justify-center">
        <Loader2 className="animate-spin text-clay" />
      </div>
    );
  }
  if (!token || !user) return <Navigate to="/admin/login" replace />;
  return children;
}
